import { format } from 'date-fns';

import { CREDIT_TRANSACTION_TYPES } from './constants';
import { GiftCardTransaction } from './types';

export function maskCardNumber({
  lastDigits,
  totalDigits = 16,
}: {
  lastDigits: string;
  totalDigits?: number;
}) {
  const maskedLength = totalDigits - lastDigits.length;
  const masked = '•'.repeat(maskedLength) + lastDigits;
  return masked.replace(/(.{4})/g, '$1 ').trim();
}

export function formatCardNumber(cardNumber: string) {
  return cardNumber?.replace(/(.{4})/g, '$1 ').trim();
}

export function formatDate(date: Date) {
  return format(date, 'MMMM dd, yyyy - hh:mm aa');
}

export function formatCentsToDollarString(cents: number = 0, precision = 2) {
  return (cents / 100).toFixed(precision);
}

export type TransactionDisplay = {
  id: string;
  type: string;
  amount: number;
  direction: 'credit' | 'debit';
  description: string;
  date: string;
};

function getTransactionDirection(type: string): 'credit' | 'debit' {
  return CREDIT_TRANSACTION_TYPES.includes(type.toLowerCase()) ? 'credit' : 'debit';
}

function getTransactionDescription(type: string): string {
  const descriptions: Record<string, string> = {
    reload: 'Funds Reload',
    refund: 'Refund',
    restaurant: 'Restaurant Order',
    digital: 'Digital Order',
    transfer_in: 'Transfer In',
    transfer_out: 'Transfer Out',
    activation: 'Card Activation',
  };
  return descriptions[type.toLowerCase()] || type;
}

export function transformTransaction(
  transaction: GiftCardTransaction,
  index: number
): TransactionDisplay {
  return {
    id: `${transaction.date}-${index}`,
    type: transaction.type,
    amount: transaction.amount,
    direction: getTransactionDirection(transaction.type),
    description: getTransactionDescription(transaction.type),
    date: transaction.date,
  };
}

export function groupTransactionsByMonth(
  transactions: GiftCardTransaction[]
): Record<string, TransactionDisplay[]> {
  const grouped: Record<string, TransactionDisplay[]> = {};

  transactions.forEach((transaction, index) => {
    const date = new Date(transaction.date);
    const monthYear = format(date, 'MMMM yyyy');

    if (!grouped[monthYear]) {
      grouped[monthYear] = [];
    }

    grouped[monthYear].push(transformTransaction(transaction, index));
  });

  return grouped;
}
